import Typography from "@mui/material/Typography";
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg";
import BreadCrumbs from "components/Breadcrumbs/index";
import InfoTooltip from "components/InfoTooltip";
import React from "react";
import { useSelector } from "react-redux";
import { Link, Route, useHistory } from "react-router-dom";
import AccountBillingTypeView from "../FinancialSettingPage/AccountBillingType/AccountBillingTypeView";
import AccountsReceivable from "../FinancialSettingPage/AccountReceivable/AccountReceivable";
import BankAccountsView from "../FinancialSettingPage/BankAccounts/BankAccountsView";
import LedgerAccounts from "../FinancialSettingPage/LedgerAccounts/LedgerAccounts";
import PaymentsTypes from "../FinancialSettingPage/PaymentsTypes/PaymentsTypes";
import ProviderInfo from "../FinancialSettingPage/ProviderInfo/index";
import ProviderInformation from "../FinancialSettingPage/ProviderInfo/ProviderInfo";
import QuickbooksInformation from "../FinancialSettingPage/QuickbooksInfo/QuickbooksInfo";
import ReversalTypes from "../FinancialSettingPage/ReversalTypes/ReversalTypes";
import TaxId from "../FinancialSettingPage/TaxId/TaxId";
import AccountTpyes from "../MembersSettingPage/AccountTpyes/AccountTpyes";
import DropDownOptions from "../MembersSettingPage/DropDownOptions/DropDownOptions";
import Tags from "../MembersSettingPage/Tags/Tags";
import TabsContent from "./TabsContent";
const routes = [
  {
    path: "/financial-setting/members/account-types",
    component: AccountTpyes,
    heading: "Account Categories",
  },
  {
    path: "/financial-setting/account-billing-types",
    component: AccountBillingTypeView,
    heading: "Account Billing Type",
  },
  {
    path: "/financial-setting/bank-accounts",
    component: BankAccountsView,
    heading: "Bank Accounts",
  },
  {
    path: "/financial-setting/ledger-accounts",
    component: LedgerAccounts,
    heading: "Ledger Accounts",
  },
  {
    path: "/financial-setting/payment-types",
    component: PaymentsTypes,
    heading: "Payment Types",
  },
  {
    path: "/financial-setting/reversal-types",
    component: ReversalTypes,
    heading: "Reversal Types",
  },
  {
    path: "/financial-setting/provider-info",
    component: ProviderInfo,
    heading: "Gateway Settings",
  },
  {
    path: "/financial-setting/software-integration",
    component: QuickbooksInformation,
    heading: "Quickbooks Info",
  },
  {
    path: "/financial-setting/accounts-receivable",
    component: AccountsReceivable,
    heading: "Accounts Receivable",
  },
  {
    path: "/financial-setting/accounts-tax-id",
    component: TaxId,
    heading: "Tax ID",
  },
  {
    path: "/financial-setting/members/dropdown-options",
    component: DropDownOptions,
    heading: "Dropdown Options",
  },
  {
    path: "/financial-setting/members/tags",
    component: Tags,
    heading: "Tags",
  }
];
const SettingsRoutes = ({ isUserManagementActive, value }) => {
  const { tagType } = useSelector((state) => state.communication);

  const displayCurrentPage = () => {
    switch (value) {
      case "1":
        return "Organization Info";
      case "2":
        return "Financial";
      case "3":
        return "Members";
      case "4":
        return "Pastoral Event Type";
      case "5":
        return "Users & Permissions";
      case "6":
        return "Communications";
      default:
        return "Settings";
    }
  };

  const links = [
    <Typography key="2" className="breadcrumb-link setting-breadcrumb-link">
      Settings
    </Typography>,
    <Typography key="2" className="breadcrumb-link setting-breadcrumb-link">
      {displayCurrentPage()}
    </Typography>,
    tagType && value === "6" && (
      <Typography key="2" className="breadcrumb-link setting-breadcrumb-link" style={{ display: "flex", alignItems: "center" }}>
        {tagType === "twiliio" ? "Twilio Setup" : "Communication preferences"}
        {tagType !== "twiliio" && (
          <InfoTooltip text="Uncheck the box below to stop this template from being sent automatically. To edit the templates, go to Communication > Templates." style={{ marginLeft: '6px', marginBottom: '2px' }} />
        )}
      </Typography>
    ),
  ];

  return (
    <>
      <Route exact={true} path="/financial-setting/">
        <div className="setting-header-main">
          <div className="settings-breadcrumbs">
            <BreadCrumbs links={links} className="" />
          </div>
        </div>
        <TabsContent
          isUserManagementActive={isUserManagementActive}
        />
      </Route>
      {routes.map((route, index) => (
        <Route key={index} exact={false} path={route.path}>
          <route.component heading={route.heading} />
        </Route>
      ))}
    </>
  );
};

export default SettingsRoutes;
